
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podatek-lesny",
      function () {
        return require("private-next-pages/podatek-lesny/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podatek-lesny"])
      });
    }
  